var map = {
	"./logo-feature-bsd.png": "a99c",
	"./logo-feature-cgjt.png": "06a7",
	"./logo-feature-gslc.png": "d205",
	"./logo-feature-gtzh.png": "873a",
	"./logo-feature-hsjs.png": "de7d",
	"./logo-feature-tdgc.png": "4531",
	"./logo-feature-tljt.png": "e874",
	"./logo-feature-ylhl.png": "ea25",
	"./logo-feature-znzz.png": "411d",
	"./logo-portal.png": "1de6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b59";